export interface IPaymentResponseSearchCriteria {
    
    paymentResponseIds:Array<string>
}


export class PaymentResponseSearchCriteria implements IPaymentResponseSearchCriteria {

    paymentResponseIds:Array<string>
    
}